"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrizeStatus = exports.DateFilterIndex = exports.RESET_USER_REWARDS_HISTORY = exports.RESET_USER_EINSTANT_HISTORY = exports.USER_EINSTANTS_HISTORY_DETAILS = exports.USER_EINSTANTS_HISTORY = exports.RESET_DIGITAL_GAMES_HISTORY = exports.DIGITAL_GAMES_HISTORY = exports.SECOND_CHANCE_TICKET_GAME_HISTORY = exports.RESET_USER_PAST_DRAW_HISTORY = exports.RESET_USER_PAST_TICKETS_ENTRY_HISTORY = exports.RESET_USER_PAST_REWARDS_HISTORY = exports.RESET_USER_PAST_ACTIVITY_HISTORY = exports.USER_PAST_DRAWS_HISTORY = exports.USER_PAST_TICKETS_ENTRY_HISTORY = exports.USER_PAST_REWARDS_HISTORY = exports.USER_PAST_ACTIVITY_HISTORY = exports.RESET_USER_DRAW_HISTORY = exports.GET_TOTAL_PENDING_POINTS = exports.RESET_USER_TICKETS_ENTRY_HISTORY = exports.RESET_USER_ACTIVITY_HISTORY = exports.UPDATE_HISTORY_FILTER = exports.UPDATE_TICKET_HISTORY_FILTER = exports.UPDATE_ACTIVITY_HISTORY_FILTER = exports.FETCH_DRAWS_BY_IDS = exports.SET_SELECTED_HISTORY_ITEM = exports.RESET_SELECTED_HISTORY_ITEM = exports.RESET_STATE = exports.DOWNLOAD_FILE = exports.USER_DRAWS_HISTORY = exports.USER_TICKETS_ENTRY_HISTORY = exports.USER_REWARDS_HISTORY_V2 = exports.USER_REWARDS_HISTORY = exports.USER_ACTIVITY_HISTORY_FILTER = exports.USER_ACTIVITY_HISTORY = void 0;
const DateFilterIndex = 'DateFilterIndex';
exports.DateFilterIndex = DateFilterIndex;
var PrizeStatus;
(function (PrizeStatus) {
    PrizeStatus["REWARDED"] = "REWARDED";
    PrizeStatus["PENDING"] = "PENDING";
    PrizeStatus["OPT_OUT"] = "OPT_OUT";
})(PrizeStatus || (exports.PrizeStatus = PrizeStatus = {}));
const USER_ACTIVITY_HISTORY = 'history/USER_ACTIVITY_HISTORY';
exports.USER_ACTIVITY_HISTORY = USER_ACTIVITY_HISTORY;
const USER_ACTIVITY_HISTORY_FILTER = 'history/USER_ACTIVITY_HISTORY_FILTER';
exports.USER_ACTIVITY_HISTORY_FILTER = USER_ACTIVITY_HISTORY_FILTER;
const USER_REWARDS_HISTORY = 'history/USER_REWARDS_HISTORY';
exports.USER_REWARDS_HISTORY = USER_REWARDS_HISTORY;
const USER_REWARDS_HISTORY_V2 = 'history/USER_REWARDS_HISTORY_V2';
exports.USER_REWARDS_HISTORY_V2 = USER_REWARDS_HISTORY_V2;
const USER_TICKETS_ENTRY_HISTORY = 'history/USER_TICKETS_ENTRY_HISTORY';
exports.USER_TICKETS_ENTRY_HISTORY = USER_TICKETS_ENTRY_HISTORY;
const USER_DRAWS_HISTORY = 'history/USER_DRAWS_HISTORY';
exports.USER_DRAWS_HISTORY = USER_DRAWS_HISTORY;
const DOWNLOAD_FILE = 'history/DOWNLOAD_FILE';
exports.DOWNLOAD_FILE = DOWNLOAD_FILE;
const RESET_STATE = 'history/RESET_STATE';
exports.RESET_STATE = RESET_STATE;
const RESET_SELECTED_HISTORY_ITEM = 'history/RESET_SELECTED_HISTORY_ITEM';
exports.RESET_SELECTED_HISTORY_ITEM = RESET_SELECTED_HISTORY_ITEM;
const SET_SELECTED_HISTORY_ITEM = 'history/SET_SELECTED_HISTORY_ITEM';
exports.SET_SELECTED_HISTORY_ITEM = SET_SELECTED_HISTORY_ITEM;
const FETCH_DRAWS_BY_IDS = 'history/FETCH_DRAWS_BY_IDS';
exports.FETCH_DRAWS_BY_IDS = FETCH_DRAWS_BY_IDS;
const UPDATE_HISTORY_FILTER = 'history/UPDATE_HISTORY_FILTER';
exports.UPDATE_HISTORY_FILTER = UPDATE_HISTORY_FILTER;
const UPDATE_ACTIVITY_HISTORY_FILTER = 'history/UPDATE_ACTIVITY_HISTORY_FILTER';
exports.UPDATE_ACTIVITY_HISTORY_FILTER = UPDATE_ACTIVITY_HISTORY_FILTER;
const UPDATE_TICKET_HISTORY_FILTER = 'history/UPDATE_TICKET_HISTORY_FILTER';
exports.UPDATE_TICKET_HISTORY_FILTER = UPDATE_TICKET_HISTORY_FILTER;
const RESET_USER_ACTIVITY_HISTORY = 'history/RESET_USER_ACTIVITY_HISTORY';
exports.RESET_USER_ACTIVITY_HISTORY = RESET_USER_ACTIVITY_HISTORY;
const RESET_USER_TICKETS_ENTRY_HISTORY = 'history/RESET_USER_TICKETS_ENTRY_HISTORY';
exports.RESET_USER_TICKETS_ENTRY_HISTORY = RESET_USER_TICKETS_ENTRY_HISTORY;
const GET_TOTAL_PENDING_POINTS = 'history/GET_TOTAL_PENDING_POINTS';
exports.GET_TOTAL_PENDING_POINTS = GET_TOTAL_PENDING_POINTS;
const RESET_USER_DRAW_HISTORY = 'history/RESET_USER_DRAW_HISTORY';
exports.RESET_USER_DRAW_HISTORY = RESET_USER_DRAW_HISTORY;
const USER_PAST_ACTIVITY_HISTORY = 'history/USER_PAST_ACTIVITY_HISTORY';
exports.USER_PAST_ACTIVITY_HISTORY = USER_PAST_ACTIVITY_HISTORY;
const USER_PAST_REWARDS_HISTORY = 'history/USER_PAST_REWARDS_HISTORY';
exports.USER_PAST_REWARDS_HISTORY = USER_PAST_REWARDS_HISTORY;
const USER_PAST_TICKETS_ENTRY_HISTORY = 'history/USER_PAST_TICKETS_ENTRY_HISTORY';
exports.USER_PAST_TICKETS_ENTRY_HISTORY = USER_PAST_TICKETS_ENTRY_HISTORY;
const USER_PAST_DRAWS_HISTORY = 'history/USER_PAST_DRAWS_HISTORY';
exports.USER_PAST_DRAWS_HISTORY = USER_PAST_DRAWS_HISTORY;
const RESET_USER_PAST_ACTIVITY_HISTORY = 'history/RESET_USER_PAST_ACTIVITY_HISTORY';
exports.RESET_USER_PAST_ACTIVITY_HISTORY = RESET_USER_PAST_ACTIVITY_HISTORY;
const RESET_USER_PAST_REWARDS_HISTORY = 'history/RESET_USER_PAST_REWARDS_HISTORY';
exports.RESET_USER_PAST_REWARDS_HISTORY = RESET_USER_PAST_REWARDS_HISTORY;
const RESET_USER_PAST_TICKETS_ENTRY_HISTORY = 'history/RESET_USER_PAST_TICKETS_ENTRY_HISTORY';
exports.RESET_USER_PAST_TICKETS_ENTRY_HISTORY = RESET_USER_PAST_TICKETS_ENTRY_HISTORY;
const RESET_USER_PAST_DRAW_HISTORY = 'history/RESET_USER_PAST_DRAW_HISTORY';
exports.RESET_USER_PAST_DRAW_HISTORY = RESET_USER_PAST_DRAW_HISTORY;
const SECOND_CHANCE_TICKET_GAME_HISTORY = 'history/SECOND_CHANCE_TICKET_GAME_HISTORY';
exports.SECOND_CHANCE_TICKET_GAME_HISTORY = SECOND_CHANCE_TICKET_GAME_HISTORY;
const DIGITAL_GAMES_HISTORY = 'history/DIGITAL_GAMES_HISTORY';
exports.DIGITAL_GAMES_HISTORY = DIGITAL_GAMES_HISTORY;
const RESET_DIGITAL_GAMES_HISTORY = 'history/RESET_DIGITAL_GAMES_HISTORY';
exports.RESET_DIGITAL_GAMES_HISTORY = RESET_DIGITAL_GAMES_HISTORY;
const USER_EINSTANTS_HISTORY = 'history/USER_EINSTANTS_HISTORY';
exports.USER_EINSTANTS_HISTORY = USER_EINSTANTS_HISTORY;
const USER_EINSTANTS_HISTORY_DETAILS = 'history/USER_EINSTANTS_HISTORY_DETAILS';
exports.USER_EINSTANTS_HISTORY_DETAILS = USER_EINSTANTS_HISTORY_DETAILS;
const RESET_USER_EINSTANT_HISTORY = 'history/RESET_USER_EINSTANT_HISTORY';
exports.RESET_USER_EINSTANT_HISTORY = RESET_USER_EINSTANT_HISTORY;
const RESET_USER_REWARDS_HISTORY = 'history/RESET_USER_REWARDS_HISTORY';
exports.RESET_USER_REWARDS_HISTORY = RESET_USER_REWARDS_HISTORY;
//# sourceMappingURL=types.js.map